<template>
  <div :class="['badge text-white', variant]">
    {{ status }}
  </div>
</template>

<script>
import Vue from "vue";
import { i18n } from '@/plugins/i18n'

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  computed: {
    status() {
      return this.row.is_deleted ? i18n.t('label.deleted') : i18n.t('label.active');
    },
    variant() {
      return this.row.is_deleted ? 'badge-danger' : 'badge-success';
    },
  },
});
</script>

<style>
</style>
